import React, { useContext, useState } from "react";
import "./Plan_Cards_Component.css";
import ComparePlansModal from "../../Common_Component/Common_Modal/ComparePlansModal/ComparePlansModal";
import { Context } from "../../../utils/context";

const Plan_Cards_Component = ({ insuranceData, selectedPlansdata }) => {
  const plans = [
    {
      title: "Bajaj Allianz Life iSecure II",
      img: "/assets/Image/aboutus/partner/img1.png",
      price: "₹ 731",
    },
    {
      title: "PNB Metlife",
      img: "/assets/Image/aboutus/partner/img2.png",
      price: "₹ 954",
    },
  ];

  const [showModal, setShowModal] = useState(false);
  const { IMG_URL } = useContext(Context);
  return (
    <section className="Plan_Cards_Component">
      <div className="plan_card_main_holder">
        <div className="row">
          {selectedPlansdata?.map((item) => {
            return (
              <div className="col-lg-4 col-md-6 col-sm-6">
                <div className="plan_card">
                  <div className="top_part">
                    <div className="logo_holder">
                      <img src={IMG_URL + item?.image} className="logo_img" />
                    </div>

                    <div className="delete_icon_holder">
                      <img
                        src="\assets\Image\plan_compare_page\close_img.png"
                        className="close_img"
                      />
                    </div>
                  </div>

                  <div className="bottom_part">
                    <div className="comapany_name_div">
                      <p className="text">{item?.name}</p>
                    </div>
                    <div className="price_div">
                      {/* <p className="price">{item?.price}</p> */}
                      <p className="price">
                        ₹
                        {Number(
                          item?.f_i_amounts?.find(
                            (a) => a?.f_insurance_type?.id === 2
                          )?.online_amount
                        ).toLocaleString("en-IN", {
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 0,
                        }) || "N/A"}
                      </p>

                      <p className="monthly_text">monthly</p>
                    </div>
                  </div>
                </div>
                <div className="premium_div">
                  <p className="text">1st Year Premium</p>
                </div>
              </div>
            );
          })}

          <div className="col-lg-4 col-md-6 col-sm-6">
            <div className="add_plan_card">
              <div
                className="img_holder"
                onClick={() => {
                  setShowModal(true);
                }}
              >
                <img
                  src="\assets\Image\plan_compare_page\add.png"
                  className="add_img"
                />
              </div>
              <p className="text">Add Plan</p>
            </div>
          </div>
        </div>
      </div>

      <ComparePlansModal
        selectedPlansdata={selectedPlansdata}
        insuranceData={insuranceData}
        show={showModal}
        onHide={() => {
          setShowModal(false);
        }}
      />
    </section>
  );
};

export default Plan_Cards_Component;
